'use client';
import React from 'react';
import Link from 'next/link';

const ELEMENT_CIRCLES = [
  { id: 'hero-wood', label: '木', color: '#7A9E7E', size: 64, top: '18%', left: '8%', floatClass: 'element-float-1' },
  { id: 'hero-fire', label: '火', color: '#C47B5A', size: 44, top: '12%', right: '12%', floatClass: 'element-float-2' },
  { id: 'hero-earth', label: '土', color: '#C4A96B', size: 52, bottom: '30%', left: '5%', floatClass: 'element-float-3' },
  { id: 'hero-metal', label: '金', color: '#A8ADB4', size: 40, bottom: '20%', right: '8%', floatClass: 'element-float-4' },
  { id: 'hero-water', label: '水', color: '#4A6B8A', size: 56, top: '45%', right: '5%', floatClass: 'element-float-5' },
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center px-6 blob-bg overflow-hidden">
      {/* Floating element circles */}
      {ELEMENT_CIRCLES?.map((el) => (
        <div
          key={el?.id}
          className={`absolute ${el?.floatClass} pointer-events-none select-none`}
          style={{
            top: el?.top,
            left: el?.left,
            right: el?.right,
            bottom: el?.bottom,
            width: el?.size,
            height: el?.size,
          }}
        >
          <div
            className="w-full h-full rounded-full flex items-center justify-center text-white font-medium"
            style={{
              backgroundColor: el?.color,
              opacity: 0.18,
              fontSize: el?.size * 0.28,
            }}
          />
        </div>
      ))}

      {/* Main content */}
      <div className="relative z-10 text-center max-w-sm mx-auto pt-24 pb-16">
        {/* Eyebrow */}
        <div className="fade-in-up stagger-1 inline-flex items-center gap-2 mb-8 px-4 py-1.5 rounded-full border border-border bg-card">
          <span className="w-1.5 h-1.5 rounded-full bg-accent" />
          <span className="text-xs font-medium text-muted-foreground tracking-widest uppercase">
            五行色彩顧問
          </span>
        </div>

        {/* Hero headline */}
        <h1 className="fade-in-up stagger-2 text-hero font-light text-foreground mb-6 leading-tight">
          找到屬於你的
          <br />
          <span className="font-semibold">居家能量色</span>
        </h1>

        {/* Subheadline */}
        <p className="fade-in-up stagger-3 text-base font-light text-muted-foreground leading-relaxed mb-12 px-2">
          從出生時刻，探索適合你的色彩、
          <br className="hidden sm:block" />
          材質與空間氣質。
        </p>

        {/* CTA */}
        <div className="fade-in-up stagger-4">
          <Link
            href="/birth-data-input"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-primary text-primary-foreground text-sm font-semibold tracking-wide transition-all duration-200 hover:bg-foreground/90 active:scale-95"
          >
            開始分析
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="opacity-70">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>

        {/* Subtle scroll hint */}
        <div className="fade-in-up stagger-5 mt-16 flex flex-col items-center gap-2">
          <span className="text-xs text-muted-foreground tracking-widest uppercase">向下探索</span>
          <div className="w-px h-8 bg-gradient-to-b from-border to-transparent" />
        </div>
      </div>

      {/* Bottom decorative element strip */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
    </section>
  );
}